//Lib
import { createAction } from '@reduxjs/toolkit';

export const Validate = createAction('VALIDATE');
export const SetValidate = createAction('SET_VALIDATE');
export const SetConfigurableMessage = createAction('SET_CONFIGURABLE_MESSAGE');
export const GetConfigurableMessage = createAction('GET_CONFIGURABLE_MESSAGE');
